module.exports = __webpack_public_path__ + "static/media/check.7e19de2b.svg";